import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { ASSETS } from "@/lib/assets";
import { ShieldAlert } from "lucide-react";

export default function Footer() {
  const { t } = useApp();
  return (
    <footer className="relative z-10 mt-24 border-t border-amber-500/15 glass" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 py-12 sm:py-14 grid gap-10 md:grid-cols-2 lg:grid-cols-4 text-center md:text-left">
        <div className="flex flex-col items-center md:items-start" data-testid="footer-about">
          <div className="flex items-center justify-center md:justify-start gap-2.5 mb-4">
            <img src={ASSETS.logo} alt="AstroFriend" className="h-9 w-9 rounded-full ring-1 ring-amber-400/50 object-cover" />
            <span className="font-serif text-xl font-bold text-gradient-gold">AstroFriend</span>
          </div>
          <h4 className="font-serif text-amber-200 mb-2">{t.footer.about}</h4>
          <p className="text-sm text-slate-400 leading-relaxed max-w-sm">{t.footer.aboutText}</p>
        </div>

        <div className="flex flex-col items-center md:items-start" data-testid="footer-links">
          <h4 className="font-serif text-amber-200 mb-3">{t.footer.links}</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/instructions" className="hover:text-amber-300">{t.nav.how}</Link></li>
            <li><Link to="/library" className="hover:text-amber-300">{t.nav.library}</Link></li>
            <li><Link to="/pricing" className="hover:text-amber-300">{t.nav.pricing}</Link></li>
            <li><Link to="/profile" className="hover:text-amber-300">{t.nav.readings}</Link></li>
          </ul>
        </div>

        <div className="flex flex-col items-center md:items-start" data-testid="footer-policies">
          <h4 className="font-serif text-amber-200 mb-3">{t.footer.policies}</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/about" data-testid="footer-link-about" className="hover:text-amber-300">{t.footer.aboutUs}</Link></li>
            <li><Link to="/services" data-testid="footer-link-services" className="hover:text-amber-300">{t.footer.services}</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-amber-300">{t.footer.contact}</Link></li>
            <li><Link to="/privacy-policy" data-testid="footer-link-privacy" className="hover:text-amber-300">{t.footer.privacy}</Link></li>
            <li><Link to="/refund-policy" data-testid="footer-link-refund" className="hover:text-amber-300">{t.footer.refund}</Link></li>
            <li><Link to="/cancellation-policy" data-testid="footer-link-cancellation" className="hover:text-amber-300">{t.footer.cancellation}</Link></li>
            <li><Link to="/shipping-policy" data-testid="footer-link-shipping" className="hover:text-amber-300">{t.footer.shipping}</Link></li>
          </ul>
        </div>

        <div className="flex flex-col items-center md:items-start" data-testid="footer-disclaimer">
          <h4 className="font-serif text-amber-200 mb-3 flex items-center justify-center md:justify-start gap-2">
            <ShieldAlert size={16} /> {t.footer.disclaimerTitle}
          </h4>
          <p className="text-xs text-slate-500 leading-relaxed max-w-sm">{t.footer.disclaimer}</p>
        </div>
      </div>
      <div className="border-t border-amber-500/10 py-5 px-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} AstroFriend. {t.footer.rights}
      </div>
    </footer>
  );
}
